angular
	.module 'App.Component'
	.component 'qrCode',
		{
			templateUrl: '@component/qr-code/qr-code.view.html'
			controller: 'QrCodeController'
			controllerAs: 'qrCode'
			bindings:
				title: '@'
				alt: '@?'
				resolveUrlCallback: '&'
				disposeUrlCallback: '&?'
		}

class QrCodeController extends AbstractController
	@register()
	@inject '$uibModal', '$q'

	onClick: ->
		@$q
			.resolve(@resolveUrlCallback())
			.then (url) =>
				@$uibModal
					.open({
						component: 'qrCodeModal'
						size: 'md'
						resolve:
							url: => url
							alt: => @alt
							title: => @title
					})
					.result
					.finally =>
						if @disposeUrlCallback?
							@disposeUrlCallback({url})
